"use client";

import React from "react";

import { SidebarWithChatHistory } from "./SidebarWithChatHistory";
import { Chat } from "./Chat";

interface ChatContainerProps {
  workflowId: string;
}

export const ChatContainer: React.FC<ChatContainerProps> = ({ workflowId }) => {
  return (
    <SidebarWithChatHistory subTitle="Chat" title="AI Assistant">
      <Chat workflowId={workflowId} />
    </SidebarWithChatHistory>
  );
};
